import { Typography, Button } from "@material-tailwind/react";
import { FlagIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";

const PageNotFoundScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-auto grid place-items-center text-center px-8">
      <div>
        <FlagIcon className="w-20 h-20 mx-auto" />
        <Typography
          variant="h1"
          color="blue-gray"
          className="mt-10 !text-3xl !leading-snug md:!text-4xl">
          Error 404 <br /> This page is unavailable
        </Typography>
        <Typography className="mt-8 mb-14 text-[18px] font-normal text-gray-500 mx-auto md:max-w-sm">
          Please contact our team if you meet any bugs or errors. Please try
          click button below to back to homepage.
        </Typography>
        <Button
          color="gray"
          className="w-full px-4 md:w-[8rem]"
          onClick={() => navigate("/")}>
          back home
        </Button>
      </div>
    </div>
  );
};

export default PageNotFoundScreen;
